import React from 'react';
import Icon from '../../../components/AppIcon';

const CICDIntegrationSection = () => {
  return (
    <section className="py-24 px-4 md:px-6 lg:px-8" style={{ backgroundColor: '#242423' }}>
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          {/* Left Column - Diagram */}
          <div>
            <div 
              className="rounded-xl p-8 md:p-10"
              style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
            >
              {/* CI/CD Pipeline Badge */}
              <div className="flex justify-center mb-8">
                <div 
                  className="inline-flex items-center px-4 py-2 rounded-md text-xs font-semibold uppercase tracking-wider"
                  style={{ backgroundColor: 'transparent', border: '1px solid #F5CB5C', color: '#F5CB5C' }}
                >
                  CI/CD Pipeline
                </div>
              </div>
              
              {/* Top Row - Git and Server Icons */}
              <div className="flex items-center justify-center gap-4 mb-6">
                <div 
                  className="w-16 h-12 rounded-lg flex items-center justify-center"
                  style={{ backgroundColor: '#242423', border: '1px solid #3A3A38' }}
                >
                  <Icon name="GitBranch" size={24} style={{ color: '#4FB3B8' }} />
                </div>
                <div className="w-8 h-px" style={{ backgroundColor: '#9CA3AF' }}></div>
                <div 
                  className="w-16 h-12 rounded-lg flex items-center justify-center"
                  style={{ backgroundColor: '#242423', border: '1px solid #F5CB5C' }}
                >
                  <Icon name="Server" size={24} style={{ color: '#F5CB5C' }} />
                </div>
              </div>
              
              {/* Vertical Line */}
              <div className="flex justify-center mb-6">
                <div className="w-px h-12" style={{ backgroundColor: '#9CA3AF' }}></div>
              </div>
              
              {/* Bottom Row - Physical HIL and Virtual Devices */}
              <div className="flex items-center justify-center gap-6">
                <div 
                  className="flex-1 max-w-48 rounded-lg p-4 flex flex-col items-center gap-3"
                  style={{ backgroundColor: '#242423', border: '1px solid #F5CB5C' }}
                >
                  <Icon name="Cpu" size={28} style={{ color: '#F5CB5C' }} />
                  <span style={{ color: '#E8EDDF', fontSize: '14px' }}>Physical HIL</span>
                </div>
                <div 
                  className="flex-1 max-w-48 rounded-lg p-4 flex flex-col items-center gap-3"
                  style={{ backgroundColor: '#242423', border: '1px solid #F5CB5C' }}
                >
                  <Icon name="Cloud" size={28} style={{ color: '#F5CB5C' }} />
                  <span style={{ color: '#E8EDDF', fontSize: '14px' }}>Virtual Devices</span>
                </div>
              </div>
            </div>
          </div>
          
          {/* Right Column - Text Content */}
          <div>
            {/* Header with Icon */}
            <div className="flex items-center gap-4 mb-6">
              <div 
                className="w-12 h-12 rounded-lg flex items-center justify-center"
                style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
              >
                <Icon name="GitBranch" size={24} style={{ color: '#4FB3B8' }} />
              </div>
              <h3 className="text-2xl md:text-3xl font-bold" style={{ color: '#E8EDDF' }}>
                Native CI/CD Integration
              </h3>
            </div>
            
            <p className="text-base mb-8 leading-relaxed" style={{ color: '#9CA3AF' }}>
              Run automated tests on physical devices and virtual replicas in parallel. Sleeve provides unified abstraction—your pipeline treats both identically. Queue physical hardware, overflow to simulators, capture artifacts automatically with declarative test fixture provisioning.
            </p>

            {/* Bullet Points */}
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 rounded-full" style={{ backgroundColor: '#4FB3B8' }}></div>
                <p className="text-base" style={{ color: '#E8EDDF' }}>Unified abstraction for physical and virtual devices</p>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 rounded-full" style={{ backgroundColor: '#4FB3B8' }}></div>
                <p className="text-base" style={{ color: '#E8EDDF' }}>Automatic overflow to simulators when hardware busy</p>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 rounded-full" style={{ backgroundColor: '#4FB3B8' }}></div>
                <p className="text-base" style={{ color: '#E8EDDF' }}>Declarative test fixture provisioning</p>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
};

export default CICDIntegrationSection;